import * as React from 'react';

var _g, _defs;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgIceCream(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ice-cream_svg__clip0_4473:47731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.964 3.448s-.845-2.13-2.686-3.205a.97.97 0 00-1.611.726s-.313 1.151-1.63 1.322h-.359a1.913 1.913 0 00-1.914 1.912c0 1.055.857 1.911 1.915 1.911h4.526a1.913 1.913 0 001.76-2.666z",
    fill: "#FCCCCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.519 21.294l-.859 4.001a.89.89 0 01-.873.705h-5.616c-.014 0-.026 0-.04-.002a.89.89 0 01-.833-.703l-.859-4 1.356-.267.736-.145 1.297-.255.346-.067.805-.159.805.159.542.106 1.313.258.737.145 1.143.224z",
    fill: "#C96A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.518 14.706l-3 6.588h-9.08l-3-6.588h15.08z",
    fill: "#DE8941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.727 14.873H5.23a.584.584 0 110-1.168h15.498a.585.585 0 110 1.168z",
    fill: "#C96A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.157 11.793a1.913 1.913 0 01-1.915 1.912h-6.23v1.68a.957.957 0 01-1.914 0v-1.68h-.693v2.48a.956.956 0 01-.957.956.956.956 0 01-.957-.955v-2.481h-1.85a1.913 1.913 0 110-3.823h12.6c1.058 0 1.916.856 1.916 1.911z",
    fill: "#FCCCCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.323 9.936H8.561a1.913 1.913 0 01-1.915-1.911c0-1.056.857-1.912 1.915-1.912h8.762c1.058 0 1.915.856 1.915 1.912a1.913 1.913 0 01-1.915 1.911z",
    fill: "#FCCCCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1 12.488c.278 0 .544-.244.532-.531a.54.54 0 00-.532-.531c-.278 0-.545.244-.532.53a.54.54 0 00.532.532zM11.512 4.95c.278 0 .545-.244.532-.531a.54.54 0 00-.532-.531c-.278 0-.545.244-.532.53a.54.54 0 00.532.532zM16.617 8.637c.278 0 .545-.244.532-.53a.54.54 0 00-.532-.532c-.278 0-.544.244-.532.531a.541.541 0 00.532.531zM17.758 12.379c.278 0 .544-.245.532-.531a.54.54 0 00-.532-.532c-.278 0-.545.245-.532.531a.54.54 0 00.532.532z",
    fill: "#F8555B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.981 11.728c.278 0 .545-.244.532-.53a.54.54 0 00-.532-.532c-.278 0-.544.244-.532.531a.54.54 0 00.532.531zM9.285 8.746c.278 0 .544-.244.532-.531a.54.54 0 00-.532-.531c-.278 0-.545.244-.532.53a.541.541 0 00.532.532zM13.087 8.204c.278 0 .545-.244.532-.531a.54.54 0 00-.532-.531c-.278 0-.545.244-.532.53a.54.54 0 00.532.532zM14.607 11.891c.278 0 .545-.244.532-.53a.54.54 0 00-.532-.532c-.278 0-.544.244-.532.531a.54.54 0 00.532.531zM14.39 4.191c.279 0 .546-.244.533-.531a.54.54 0 00-.532-.531c-.278 0-.545.244-.532.531a.54.54 0 00.532.531z",
    fill: "#A61E24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.572 20.56h-.745V26h.745v-5.44zM14.325 20.56h-.744V26h.744v-5.44zM16.41 20.585l-.034.484-.33 4.891a.88.88 0 01-.259.04h-.49l.342-5.076.027-.39.743.051zM10.877 26h-.706c-.014 0-.027 0-.04-.003l-.336-4.97-.03-.442.743-.05.023.347.346 5.117z",
    fill: "#DE8941"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ice-cream_svg__clip0_4473:47731"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  })))));
}

export { SvgIceCream as default };